import { Button, Flex, Image, Input, Modal, Tag, Typography } from 'antd';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const MapAssignmentModalContainer = styled(Modal)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    .ant-modal-content {
      height: 772px;
      display: flex;
      flex-direction: column;
      padding: 0;
    }

    .ant-modal-header {
      margin: 0 0 8px 0;
      padding: ${kcc.size.S250}px ${kcc.size.S250}px 0;
      font-size: ${kcc.typography.FONT_SIZE.HEADING_4}px;
    }

    .ant-modal-body {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-height: 0;
      padding: 0;
      overflow: hidden;
    }

    .ant-modal-footer {
      margin: ${kcc.size.S200}px 0 0 0;
      padding: 0 ${kcc.size.S250}px ${kcc.size.S250}px;
    }
  `}
`;

export const MapAssignmentCloseButton = styled(Button)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    flex-shrink: 0;
    width: ${kcc.size.S300}px;
    height: ${kcc.size.S300}px;
    padding: 0;

    svg {
      width: ${kcc.size.S300}px;
      height: ${kcc.size.S300}px;
    }
  `}
`;

export const MapAssignmentSearchContainer = styled(Flex)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    flex-shrink: 0;
    padding-inline: ${kcc.size.S250}px;
    margin-bottom: ${kcc.size.S200}px;
    margin-top: ${kcc.size.S50}px;
  `}
`;

export const MapAssignmentSearchInput = styled(Input)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    height: ${kcc.size.S500}px;
    align-items: center;

    .ant-input-prefix {
      margin-inline-end: ${kcc.size.S100}px;
    }

    .ant-input::placeholder {
      color: ${kcc.colors.TEXT_PLACEHOLDER};
      display: inline-block;
      transform: translateY(1px);
    }
  `}
`;

export const MapAssignmentSelectionTag = styled(Tag)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    display: inline-flex;
    align-self: flex-start;
    align-items: center;
    height: ${kcc.size.S400}px;
    gap: ${kcc.size.S100}px;
    padding-inline: ${kcc.size.S200}px;
    border: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.BLACK};
    color: ${kcc.colors.BLACK};
    font-size: ${kcc.typography.FONT_SIZE.BASE}px;
    font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    cursor: pointer;

    svg {
      display: block;
      width: 16px;
      height: 16px;
    }
  `}
`;

export const MapAssignmentListsWrapper = styled(Flex)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    flex: 1;
    min-height: 0;
    gap: ${kcc.size.S300}px;
    padding: 0 ${kcc.size.S250}px ${kcc.size.S250}px;
  `}
`;

export const MapAssignmentListContainer = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    border-inline: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.BORDER};
    border-block-end: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.BORDER};
  `}
`;

export const MapAssignmentListRows = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const MapAssignmentListRow = styled(Flex)<{
  $isHeader?: boolean;
  $noTopBorder?: boolean;
  $noBottomBorder?: boolean;
}>`
  ${({ theme: { kcc }, $isHeader, $noTopBorder, $noBottomBorder }): FlattenSimpleInterpolation => css`
    height: 48px;
    flex-shrink: 0;
    align-items: stretch;
    border-block: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.BORDER};
    ${$noTopBorder && 'border-top: none;'}
    ${$noBottomBorder && 'border-bottom: none;'}
    background-color: ${$isHeader ? kcc.colors.BG_LAYOUT : 'transparent'};

    .ant-typography {
      line-height: ${kcc.typography.LINE_HEIGHT.SM};
    }

    & + & {
      margin-top: -${kcc.lineWidth.BORDER}px;
    }

    ${!$isHeader &&
    css`
      cursor: pointer;

      &:hover {
        background-color: ${kcc.colors.BG_LAYOUT};
      }
    `}
  `}
`;

export const MapAssignmentRowLeft = styled(Flex)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    flex-shrink: 0;
    align-items: center;
    padding-block: ${kcc.size.S200}px;
    padding-inline: 14px;
  `}
`;

export const MapAssignmentRowDivider = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    align-self: center;
    width: 0.75px;
    height: ${kcc.size.S250}px;
    background-color: ${kcc.colors.BORDER};
  `}
`;

export const MapAssignmentRowRight = styled(Flex)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    flex: 1;
    min-width: 0;
    align-items: center;
    padding-block: 14px;
    padding-inline: ${kcc.size.S150}px;
  `}
`;

export const MapAssignmentGroupRowRight = styled(Flex)`
  flex: 1;
  min-width: 0;
  align-items: center;
`;

export const MapAssignmentGroupColumn = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    flex: 1 1 50%;
    min-width: 0;
    padding-block: 14px;
    padding-inline: ${kcc.size.S150}px;
  `}
`;

export const MapAssignmentMapItemRight = styled(Flex)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    flex: 1;
    min-width: 0;
    align-items: center;
    padding-block: ${kcc.size.S100}px;
    padding-inline: ${kcc.size.S150}px;
  `}
`;

export const MapAssignmentMapImage = styled(Image)`
  flex-shrink: 0;

  img {
    object-fit: cover;
  }
`;

export const MapAssignmentSectionTitleText = styled(Typography.Text)`
  font-weight: ${({ theme: { kcc } }): number => kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
`;
